import {Card} from "react-bootstrap";
import React from "react";



function ServiceDeviceConnections({data}) {

    const percentUp = (total, down) => {
        return(
            `${((total - down)*100/total).toFixed(2)}%`
        )
    }

    return (
        <>


            <Card bg="light" className="m-2 overflow-hidden" style={{ height: '12rem' }}>
                <Card.Title className="fw-bold px-2 pt-1 mb-0 fs-3 text-center dash-title">
                    Meters Online ({percentUp(data.totalDevices, data.downDevices)})
                </Card.Title>

                <Card.Body className="fs-4 py-1">
                    {/* <div className="fs-3 fw-bold d-inline">{data.totalDevices - data.downDevices}</div>
                    <div className="d-inline"> of </div>
                    <div className="fs-3 fw-bold d-inline">{data.totalDevices}</div>
                    <div className="d-inline "> total meters online. </div>
                    <div className="fs-5 fw-bold d-inline">({percentUp(data.totalDevices, data.downDevices)})</div> */}
                    <div className="text-center">
                        <span className="fs-3 fw-bold d-inline">{data.totalDevices - data.downDevices}</span>
                        <span> of </span>
                        <span className="fs-3 fw-bold d-inline">{data.totalDevices}</span>
                        <span> total meters online.</span>
                    </div>
                </Card.Body>

            </Card>

        </>
    );
}

export default ServiceDeviceConnections;
